
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ConfirmationPopup extends Vue {
  @Prop({ default: 'Do you really want to do this action?' }) text: string
  @Prop({ default: 'Yes' }) okButtonText: string
  @Prop({ default: 'Cancel' }) cancelButtonText: string

  acceptConfirmation(): void {
    this.$emit('confirmation')
    this.$store.commit('confirmation/close')
  }
}
